import packageInfo from "../package.json";

// config.js (updated for Option 1: runtime env.js via window.__ENV)

// window.__ENV will be injected at runtime by the container (env.js).
// Fallback to CRA build-time env (process.env) for local/dev or if env.js is missing.
const RUNTIME_ENV =
	(typeof window !== "undefined" && window.__ENV) ? window.__ENV : {};

// Read helper: runtime -> build-time -> fallback
const readEnv = (key, fallback = "") => {
	const runtimeVal = RUNTIME_ENV[key];
	if (runtimeVal !== undefined && runtimeVal !== null && String(runtimeVal).length > 0) return runtimeVal;

	const buildVal = process.env[key];
	if (buildVal !== undefined && buildVal !== null && String(buildVal).length > 0) return buildVal;

	return fallback;
};

// Boolean helper (handles "true"/"false"/true/false)
const readBool = (key, fallback = false) => {
	const val = readEnv(key, fallback ? "true" : "false");
	return String(val).toLowerCase() === "true";
};

const isSslEnabled = readBool("REACT_APP_SSL_ENABLED", false);

// Chat URL
const CHAT_URL = readEnv(
	"REACT_APP_CHAT_URL",
	"http://44.213.176.147:3003/chatbot/iecom"
);

// URLs based on SSL setting
const API_BASE_URL = isSslEnabled
	? readEnv("REACT_APP_API_BASE_URL_HTTPS")
	: readEnv("REACT_APP_API_BASE_URL_HTTP");

const ASSETS_BASE_URL = isSslEnabled
	? readEnv("REACT_APP_ASSETS_BASE_URL_HTTPS")
	: readEnv("REACT_APP_ASSETS_BASE_URL_HTTP");

const SERVER_BASE_URL = isSslEnabled
	? readEnv("REACT_APP_SERVER_BASE_URL_HTTPS")
	: readEnv("REACT_APP_SERVER_BASE_URL_HTTP");

const DEFAULT_RSPL_LIST = JSON.parse(
	'[{"key":["A"],"value":"Critical"},{"key":["B","C"],"value":"Maintainence"}]'
);

const DEFAULT_AXIS_MODEL_VIEWER = readEnv("REACT_APP_MODEL_VIEWER_START_AXIS", "X_UP");

const parseRsplList = (rawValue, fallback = DEFAULT_RSPL_LIST) => {
	if (!rawValue) return fallback;
	const parsed = Array.isArray(rawValue)
		? rawValue
		: (() => {
				try {
					return JSON.parse(rawValue);
				} catch {
					return null;
				}
			})();
	if (!Array.isArray(parsed)) return fallback;
	const sanitized = parsed.filter(
		(item) =>
			item &&
			typeof item.value === "string" &&
			Array.isArray(item.key) &&
			item.key.every((entry) => typeof entry === "string")
	);
	return sanitized.length > 0 ? sanitized : fallback;
};

let RSPL_LIST = parseRsplList(readEnv("REACT_APP_RSPL_LIST", ""));

const setRsplListFromOptions = (optionValue) => {
	RSPL_LIST = parseRsplList(optionValue, RSPL_LIST);
	return RSPL_LIST;
};

const COMPANY_NAME = readEnv("REACT_APP_COMPANY_NAME", "ITHENA");
const COMPANY_EMAIL = readEnv("REACT_APP_COMPANY_EMAIL", "support@ithena.ai");
const COMPANY_PHONE = readEnv("REACT_APP_COMPANY_PHONE", "+1 (804) 399-0051");
const COMPANY_ADDRESS = readEnv(
	"REACT_APP_COMPANY_ADDRESS",
	"4470 Cox Rd #275, Glen Allen, VA 23060"
);

const COMPANY_SOCIAL1 = readEnv("REACT_APP_COMPANY_SOCIAL1", "https://www.facebook.com/ithenaai");
const COMPANY_SOCIAL2 = readEnv("REACT_APP_COMPANY_SOCIAL2", "https://www.linkedin.com/company/ithena-ai");
const COMPANY_SOCIAL3 = readEnv("REACT_APP_COMPANY_SOCIAL3", "https://twitter.com/ithenaai");
const COMPANY_SOCIAL4 = readEnv("REACT_APP_COMPANY_SOCIAL4", "https://www.youtube.com/@ithenaai");

const SOCKET_BASE_URL = readEnv("REACT_APP_SOCKET_URL", "");
const SOCKET_API_KEY = readEnv("REACT_APP_SOCKET_API_KEY", "");

const OPENPANEL_CLIENT_ID = readEnv("REACT_APP_OPENPANEL_CLIENT_ID", "");
const OPENPANEL_API_URL = readEnv("REACT_APP_OPENPANEL_API_URL", "http://localhost:8000/api");
const OPENPANEL_DEBUG = readBool("REACT_APP_OPENPANEL_DEBUG", process.env.NODE_ENV !== "production");

const ICRASH_DSN = readEnv(
	"REACT_APP_ICRASH_DSN",
	"https://60caecd59ed1b3be718d5066eefe7549@icrash-analytics.ithena.app/2"
);
const ICRASH_ENVIRONMENT = readEnv(
	"REACT_APP_ICRASH_ENVIRONMENT",
	readEnv("REACT_APP_ENVIRONMENT", process.env.NODE_ENV || "development")
);
const ICRASH_RELEASE = readEnv("REACT_APP_ICRASH_RELEASE", packageInfo.version);

const DEFAULT_LAYOUT = readEnv("REACT_APP_DEFAULT_LAYOUT", "layout1");

// Keep your old fallback keys too (DOCUMENT_EXTERNAL, etc.)
const DOCUMENT_EXTERNAL_ENABLED =
	String(
		readEnv("REACT_APP_DOCUMENT_EXTERNAL", readEnv("DOCUMENT_EXTERNAL", "false"))
	).toLowerCase() === "true";

const DOCUMENT_EXTERNAL_URL =
	readEnv("REACT_APP_DOCUMENT_EXTERNAL_URL", readEnv("DOCUMENT_EXTERNAL_URL", ""));

const EXTERNAL_2D_ENABLED =
	String(readEnv("REACT_APP_EXTERNAL_2D", readEnv("EXTERNAL_2D", "true"))).toLowerCase() === "true";

export {
	API_BASE_URL,
	ASSETS_BASE_URL,
	SERVER_BASE_URL,
	RSPL_LIST,
	CHAT_URL,
	COMPANY_ADDRESS,
	COMPANY_EMAIL,
	COMPANY_NAME,
	COMPANY_PHONE,
	COMPANY_SOCIAL1,
	COMPANY_SOCIAL2,
	COMPANY_SOCIAL3,
	COMPANY_SOCIAL4,
	SOCKET_BASE_URL,
	SOCKET_API_KEY,
	OPENPANEL_CLIENT_ID,
	OPENPANEL_API_URL,
	OPENPANEL_DEBUG,
	ICRASH_DSN,
	ICRASH_ENVIRONMENT,
	ICRASH_RELEASE,
	DEFAULT_LAYOUT,
	DOCUMENT_EXTERNAL_ENABLED,
	DOCUMENT_EXTERNAL_URL,
	EXTERNAL_2D_ENABLED,
	DEFAULT_AXIS_MODEL_VIEWER,
	setRsplListFromOptions,
};
